import { MutationHookOptions, useMutation } from '@apollo/client';

import mutation from './createDepotBulkImport.graphql';

export const useCreateDepotBulkImportMutation = (
  opts?: MutationHookOptions<
    CreateDepotBulkImportMutation,
    CreateDepotBulkImportMutationVariables
  >,
) => {
  return useMutation<
    CreateDepotBulkImportMutation,
    CreateDepotBulkImportMutationVariables
  >(mutation, opts);
};
